import React, { createContext, useState } from "react";
import { AditivoType, SecaoAditivosContextProps, SecaoAditivosProviderProps } from "./types";

export const SecaoAditivosContext = createContext<SecaoAditivosContextProps>({})

export function SecaoAditivosProvider({ children }: SecaoAditivosProviderProps) {
  const [modalAditivoAberto, setModalAditivoAberto] = useState(false)
  const [aditivoSelecionado, setAditivoSelecionado] = useState<AditivoType|null>(null)
  
  function buscarSituacaoAditivo(aditivo: AditivoType|null) {
    if(!aditivo) {
      return ''
    }
    let situacaoAditivo = ''
    if (!!Number(aditivo.cancelado)) {
      return ' - Cancelado'
    }
    switch (aditivo.situacao) {
      case 'S':
        situacaoAditivo = 'Solicitado'
        break
      case 'A':
        situacaoAditivo = 'Autorizado'
        break
      case 'R':
        if(aditivo.solicitacao_renegociacao_situacao == 'C') {
          situacaoAditivo = 'Renegociação Cancelada'
          break
        }
        if((aditivo.solicitacao_renegociacao_situacao || 'F') != 'F') {
          situacaoAditivo = 'Em Renegociação'
          break
        }
        situacaoAditivo = 'Aguardando Impressão'
        break
      case 'I':
        if (aditivo.analise_aprovacao == 'R') {
          situacaoAditivo = 'Reprovado'
          break
        }
        if (aditivo.analise_aprovacao == 'P') {
          situacaoAditivo = 'Pendente de Aprovação'
          break
        }
        if (aditivo.analise_aprovacao == 'A' && aditivo.tipo_motivo == 'U') {
          situacaoAditivo = 'Aguardando Liberação de Unidade'
          break
        }
        situacaoAditivo = 'Aguardando Upload'
        break
      case 'F':
        situacaoAditivo = 'Finalizado'
        break;
    }
    return situacaoAditivo && ` - ${situacaoAditivo}` || ''
  }
  
  function abrirModalAditivo(aditivo?: AditivoType, idxAditivo?: number) {
    if(aditivo) {
      aditivo.idx = idxAditivo
      setAditivoSelecionado(aditivo)
    }
    setModalAditivoAberto(true)
  }

  function fecharModalAditivo() {
    setModalAditivoAberto(false)
    setAditivoSelecionado(null)
  }
  
  return <SecaoAditivosContext.Provider 
    value={{ buscarSituacaoAditivo, modalAditivoAberto, aditivoSelecionado, fecharModalAditivo, abrirModalAditivo }}
  >
    {children}
  </SecaoAditivosContext.Provider>
}
